export const BUY_PAGES_TO_IGNORE_AMP = [
    'vintage-and-antique-propellers',
    'cannons',
    'plantation-chairs',
    'sterling-silver-wine-coolers-and-champagne-buckets',
    'japanese-silk-paintings',
    'exhibition-posters',
    'barometers',
    'chanel-diana-bags',
    'elephant-tables',
    'library-tables',
    'antique-golf-clubs',
    'giant-clam-shells',
    'peacock-chairs',
    'carousel-horses',
    'french-bistro-tables',
    'mushroom-lamps',
    'antique-backgammon-boards',
    'antique-kitchen-islands',
    'trash-cans',
    'bronze-horse-sculptures',
    'vintage-rocking-horse',
    'carriage-clocks',
    'dental-cabinets',
    'ivory-carvings',
    'library-ladders',
    'music-cabinets',
    'stained-glass-windows',
    'vintage-antique-bicycles',
    'vintage-travel-trunks',
    'balloon-chair',
    'gold-omega-watch',
    'portrait-miniatures',
    'vintage-croquet-sets-and-accessories',
    'vintage-perfume-bottles',
    'wood-rocking-horses',
    'ballerina-paintings',
    'bell-jar-lantern',
    'bobbin-chairs',
    'bombe-chest',
    'bracket-clocks',
    'bronze-dog-sculptures',
    'byobu-screens',
    'chanel-mini-flap-bags',
    'chinese-porcelain-table-lamps',
    'cornflower-blue-sapphire-rings',
    'garden-stools',
    'leather-folding-chairs',
    'leather-safari-chairs',
    'mannequins',
    'native-american-blankets',
    'paraiba-tourmaline-jewelry',
    'siesta-chairs',
    'tile-top-coffee-tables',
    'vintage-chanel-buttons',
    'vintage-glass-decanters',
    'vintage-silver-goblets',
    'antique-epergnes',
    'antique-teapots',
    'art-deco-ivory-sculptures',
    'barrel-chairs',
    'bistro-tables',
    'camelback-sofas',
    'carved-wood-owls',
    'ceramic-panthers',
    'chopard-floating-diamond-watches',
    'church-chandeliers',
    'crystal-cocktail-shakers',
    'cube-coffee-tables',
    'dragon-lamps',
    'extendable-oval-dining-tables',
    'gentlemans-chairs',
    'ginger-jar-lamps',
    'glass-roosters',
    'gold-locket-necklaces',
    'hand-painted-mirrors',
    'handmade-afghan-rugs',
    'hermes-kelly-32cm-handbags',
    'indian-mirrors',
    'italian-alabaster-sculptures',
    'italian-marble-dining-tables',
    'jadeite-jewelry',
    'japanese-bronze-sculptures',
    'kate-moss-prints',
    'ladder-back-chairs',
    'men-diamond-rings',
    'mens-diamond-rolex-watches',
    'monkey-chandeliers',
    'monkey-tables',
    'moroccan-carpet-runners',
    'murano-glass-decanters',
    'mystery-clocks',
    'octagon-side-tables',
];

export const BUY_PAGE_FILTERS = ['price', 'priceTrade', 'location'];
